"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _index = _interopRequireDefault(require("../splice/index.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Immutably adds an item to the specified index of the array
 * 
 * @category Array
 * @param {array} array - The original array
 * @param {number} index - The index to insert the item
 * @param {*} item - The item to insert
 * @returns {array} - The new array
 * @example
 * const array = ['dog', 'cat', 'bird'];
 * const newArray = insertAt(array, 1, 'fish');
 * // => ['dog', 'fish', 'cat', 'bird']
 */
var _default = function _default(array, index, item) {
  if (array === undefined || array === null || array.length <= 0) return array;
  if (index < 0 || array.length <= index) throw 'Index outside of bounds of the array.';
  return (0, _index.default)(array, index, 0, item);
};

exports.default = _default;